import { AfterViewInit, Directive, ElementRef, NgZone } from '@angular/core';

@Directive({
  selector: '[appDateRangeAddId]',
  standalone: true
})
export class DateRangeAddIdDirective implements AfterViewInit {

  constructor(private el: ElementRef, private ngZone: NgZone) { }
  
  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      const observer = new MutationObserver(() => {
        this.addIdsToCalendarButtons();
      });

      observer.observe(this.el.nativeElement, {
        childList: true,
        subtree: true
      });

      this.addIdsToCalendarButtons();
    });
  }

  private addIdsToCalendarButtons() {
    const element = this.el.nativeElement;

    // Años (en modo multi-year view)
    const yearButtons = element.querySelectorAll('.mat-calendar-body-cell');

    yearButtons.forEach((btn: HTMLElement) => {
      const text = btn.innerText.trim();
      if (/^\d{4}$/.test(text)) {
        // Año con formato: year-2025
        btn.id = `global-date-range-btn-year-${text}`;
      } else if (/[A-Z]{3}$/.test(text)) {
        // Mes abreviado con formato: month-Jan, month-Feb, etc.
        btn.id = `global-date-range-btn-month-${text.toLowerCase()}`;
      }
    });
  }

}
